// extracted by mini-css-extract-plugin
export default {"modalStyle":"modal_modalStyle__F4ZCs"};